import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTopUniversal } from "./helper";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTopUniversal();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
